export enum VerificationMethodType {

    None = 0,
    SMS = 1,
    Call = 2,
    Email = 3
}
